import { declareParams } from '@farfetched/core';
import { zodContract } from '@farfetched/zod';
import { createAuthMutation } from '../auth-http-client';
import { bonusSchema } from '../types';

export type EditBonusMutationParams = {
	id: number;
	depositRate: number;
	activationThreshold: number;
};

export const createEditBonusMutation = () =>
	createAuthMutation({
		params: declareParams<EditBonusMutationParams>(),
		request: {
			method: 'PATCH',
			url: ({ id }) => `bonus/${id}`,
			body: (data) => data,
		},
		response: {
			contract: zodContract(bonusSchema),
		},
	});
